"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/* eslint-disable class-methods-use-this */
var store = require('./store');
var botList = require('./botlist');
var helpers = require('./helpers');
var storageKey = '_constructorio_is_human';
var humanEvents = ['scroll', 'resize', 'touchmove', 'mouseover', 'mousemove', 'keydown', 'keypress', 'keyup', 'focus'];
var HumanityCheck = /*#__PURE__*/function () {
  function HumanityCheck() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, HumanityCheck);
    // Check if a human event has been performed in the past
    this.hasPerformedHumanEvent = this.getIsHumanFromSessionStorage();

    // Humanity proved, remove handlers
    var _remove = function remove() {
      _this.hasPerformedHumanEvent = true;
      store.session.set(storageKey, true);
      humanEvents.forEach(function (eventType) {
        helpers.removeEventListener(eventType, _remove, true);
      });
    };

    // Add handlers to prove humanity
    if (!this.hasPerformedHumanEvent) {
      humanEvents.forEach(function (eventType) {
        helpers.addEventListener(eventType, _remove, true);
      });
    }
  }

  // Helper function to grab the human variable from session storage
  return (0, _createClass2["default"])(HumanityCheck, [{
    key: "getIsHumanFromSessionStorage",
    value: function getIsHumanFromSessionStorage() {
      return !!store.session.get(storageKey) || false;
    }

    // Return boolean indicating if user is a bot
    // ...if it has a bot-like useragent
    // ...or uses webdriver
    // ...or has not performed a human event
  }, {
    key: "isBot",
    value: function isBot() {
      var _helpers$getNavigator = helpers.getNavigator(),
        userAgent = _helpers$getNavigator.userAgent,
        webdriver = _helpers$getNavigator.webdriver;
      var botRegex = new RegExp("(".concat(botList.join('|'), ")"));

      // Always check the user agent and webdriver fields first to determine if the user is a bot
      if (Boolean(userAgent.match(botRegex)) || Boolean(webdriver)) {
        return true;
      }

      // If the user hasn't performed a human event, it indicates it is a bot
      if (!this.getIsHumanFromSessionStorage()) {
        return true;
      }

      // Otherwise, it is a human
      return false;
    }
  }]);
}();
module.exports = HumanityCheck;